<template src="@/templates/reservations/participants.html"></template>

<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';
import { restEndpoint } from '@/config.json';
import userAuthStore from '@/store/userAuthStore';

export default {
  props: [
    'reservationId',
  ],
  data() {
    return {
      participants: [],
      loadingOne: true,
      loadingTwo: true,
      generalInfo: {},
      token: userAuthStore.state.token,
      entity: entityStore.state,
    };
  },
  computed: {
    isLoading() {
      return (this.loadingOne || this.loadingTwo);
    },
    ageCategories() {
      const ageCategories = [];
      if (typeof this.generalInfo.age_categories !== 'undefined' && this.generalInfo.age_categories !== {}) {
        const keys = Object.keys(this.generalInfo.age_categories);

        keys.forEach((item) => {
          const currentAgeCategory = this.generalInfo.age_categories[item];

          // check if anything was found
          if (typeof currentAgeCategory === 'undefined') return;

          // filter out any unhwanted ranges
          if (this.entity.name === 'amigo') {
            if (item === '46-55' || item === '56-65' || item === '66-75' || item === '76 en ouder') return;
          }
          const newCategory = {
            name: item,
            percentage: currentAgeCategory.percentage,
          };
          ageCategories.push(newCategory);
        });
      }
      return ageCategories;
    },
    malePercentage() {
      let malePercentage = '0';
      if (typeof this.generalInfo.male_female_ratio !== 'undefined') {
        if (typeof this.generalInfo.male_female_ratio.malePercentage !== 'undefined') {
          malePercentage = this.generalInfo.male_female_ratio.malePercentage;
        }
      }
      return malePercentage;
    },
    femalePercentage() {
      let femalePercentage = '0';
      if (typeof this.generalInfo.male_female_ratio !== 'undefined') {
        if (typeof this.generalInfo.male_female_ratio.femalePercentage !== 'undefined') {
          femalePercentage = this.generalInfo.male_female_ratio.femalePercentage;
        }
      }
      return femalePercentage;
    },
    averageAge() {
      let averageAge = '0';
      if (typeof this.generalInfo.average_age !== 'undefined') {
        averageAge = this.generalInfo.average_age;
      }
      return averageAge;
    },
    downloadUrl() {
      return `${restEndpoint}/reservation/${this.reservationId}/participants/download`;
    },
    groupSize() {
      let groupSize = '0';
      if (typeof this.generalInfo.group_size !== 'undefined') {
        groupSize = this.generalInfo.group_size;
      }
      return groupSize;
    },
    showAgeCategories() {
      return this.entity.name !== 'aircruise' && this.entity.name !== 'friendshipcruises';
    },
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loadingOne = true;
      this.loadingTwo = true;
      userApi.getParticipants(this.reservationId, (data) => {
        this.participants = data.participants;
        this.loadingOne = false;
      });
      userApi.getGeneralInfo(this.reservationId, (data) => {
        this.generalInfo = data.general_info;
        this.loadingTwo = false;
      });
    },
    downloadParticipantsList() {
      userApi.downloadParticipantsList(this.reservationId);
    },
    getFirstname(passenger) {
      return entityStore.getFirstname(passenger);
    },
    formatName(passenger) {
      return entityStore.formatPassengerName(passenger);
    },
    formatNameLong(passenger) {
      return entityStore.formatPassengerNameLong(passenger);
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// participants.vue?609c7209